import { Platform } from "quasar"
import { Preferences } from '@capacitor/preferences';

export async function SAVE_ACCESS_TOKEN(state, [access_token, refresh_token, user_firebase_token]) {
	state.access_token = access_token
	state.refresh_token = refresh_token
	state.user_firebase_token = user_firebase_token
	if (Platform.is.ios) {
		await Preferences.set({
			key: 'access_token',
			value: access_token,
		})
		await Preferences.set({
			key: 'refresh_token',
			value: refresh_token,
		})
		await Preferences.set({
			key: 'user_firebase_token',
			value: user_firebase_token,
		})
	}
}

export function SAVE_USER_TOKEN(state, [access_token]) {
	state.access_token = access_token
}

export function SAVE_USER_DATA(
	state,
	[
		accept_terms_and_conditions,
		email,
		full_name,
		has_mandatory_surveys,
		id,
		id_user_campaign_selected,
		id_user_client_country_selected,
		id_user_client_profile,
		id_user_client_selected,
		id_user_language_selected,
		is_superuser,
		user_client_module_items,
		user_clients,
		user_firebase_document,
		user_firebase_document_ranking_areas,
		user_image,
		user_reward_campaign,
		user_branches,
		user_campaigns,
		status,
		accept_cookies_policy,
		has_mandatory_drills,
		document,
		birthday,
		phone_mobile_number,
		email_unsubscribe,
		created_at,
	]
) {
	state.accept_terms_and_conditions = accept_terms_and_conditions
	state.email = email
	state.full_name = full_name
	state.has_mandatory_surveys = has_mandatory_surveys
	state.id = id
	state.id_user_campaign_selected = id_user_campaign_selected
	state.id_user_client_country_selected = id_user_client_country_selected
	state.id_user_client_profile = id_user_client_profile
	state.id_user_client_selected = id_user_client_selected
	state.id_user_language_selected = id_user_language_selected
	state.is_superuser = is_superuser
	state.user_client_module_items = user_client_module_items
	state.user_clients = user_clients.sort((a, b) => {
		return a.name.trim() === b.name.trim() ? 0 : a.name.trim() < b.name.trim() ? -1 : 1
	})
	state.user_firebase_document = user_firebase_document
	state.user_firebase_document_ranking_areas = user_firebase_document_ranking_areas
	state.user_image = user_image
	state.user_reward_campaign = user_reward_campaign
	state.user_branches = user_branches
	state.user_campaigns = user_campaigns
	state.status = status
	state.accept_cookies_policy = accept_cookies_policy
	state.has_mandatory_drills = has_mandatory_drills
	state.has_close_banner_drills = true
	state.document = document
	state.birthday = birthday
	state.phone_mobile_number = phone_mobile_number
	state.email_unsubscribe = email_unsubscribe
	if (created_at !== undefined) state.created_at = created_at
}

export function SAVE_EMAIL_UNSUBSCRIBE(state, [email_unsubscribe]) {
	state.email_unsubscribe = email_unsubscribe
}

export function SAVE_USER_COUNTRIES(state, [user_countries]) {
	state.user_countries = user_countries
}

export function SAVE_TERMS_AND_CONDITIONS(state, [accept_terms_and_conditions]) {
	state.accept_terms_and_conditions = accept_terms_and_conditions
}

export function SAVE_USER_IMAGE(state, [user_image]) {
	state.user_image = user_image
}

export function SAVE_RELOAD_CONTENT(state, [reload_content]) {
	state.reload_content = reload_content
}

export function SAVE_CLIENT(state, [id_user_client_selected]) {
	state.id_user_client_selected = id_user_client_selected
}

export function SAVE_COUNTRY(state, [id_user_client_country_selected]) {
	state.id_user_client_country_selected = id_user_client_country_selected
}

export function SAVE_LANGUAGE(state, [id_user_language_selected]) {
	state.id_user_language_selected = id_user_language_selected
}

export function SAVE_LANGUAGE_CODE(state, [user_language_selected]) {
	state.user_language_selected = user_language_selected
}

export function SAVE_LEFT_MENU(state, [left_menu]) {
	state.left_menu = left_menu
}

export function SAVE_RIGHT_MENU(state, [right_menu]) {
	state.right_menu = right_menu
}

export function SAVE_ADMIN_LEFT_MENU(state, [admin_left_menu]) {
	state.admin_left_menu = admin_left_menu
}

export function SAVE_MANDATORY_SURVEYS(state, [has_mandatory_surveys]) {
	state.has_mandatory_surveys = has_mandatory_surveys
}

export function SAVE_MANDATORY_DRILL(state, [has_mandatory_drills]) {
	state.has_mandatory_drills = has_mandatory_drills
}

export function SAVE_HAS_CLOSE_BANNER_DRILLS(state, [has_close_banner_drills]) {
	state.has_close_banner_drills = has_close_banner_drills
}

export function SAVE_WEBSERVICE_TOKEN(state, [webservice_token]) {
	state.webservice_token = webservice_token
}

export function SAVE_DEVICE_TOKEN(state, [device_token]) {
	state.device_token = device_token
}

export function SAVE_USER_CHANGE_PASSWORD(state, [user_change_password]) {
	state.user_change_password = user_change_password
}

export function SAVE_ID_USER_CAMPAIGN_SELECTED(state, [id_user_campaign_selected]) {
	state.id_user_campaign_selected = id_user_campaign_selected
}

export function SAVE_REDIRECT_URL(state, [redirect_url]) {
	state.redirect_url = redirect_url
}

export function SAVE_COOKIES_POLICY(state, [accept_cookies_policy]) {
	state.accept_cookies_policy = accept_cookies_policy
}

export function SAVE_DATE_REQUEST_USER_DATA(state, [date]) {
	state.date_request_set_user_data = date
}

export function SAVE_MUST_CHANGE_PASSWORD(state, must_change_password) {
	state.must_change_password = must_change_password
}

export function SAVE_SET_LOCALE_PROCESSED(state, set_locale_processed) {
	state.set_locale_processed = set_locale_processed
}

export function SAVE_VERIFICARION_PHONE_BUTTON(state, payload) {
	state.verificacion_phone_button = payload

}

export function RESET_VERIFICACION_PHONE(state) {
	state.verificacion_phone_button = { startTime: null, duration: 300 }
}

export function SAVE_INSIDER_INIT_DISPATCHED(state, value) {
	state.insider_init_dispatched = value
}
